import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withTranslation } from 'react-i18next';
import { Paper, PaperTitle } from 'virtues-bootstrap';
import PropTypes from 'prop-types';

import AccordionRenderer from 'components/AccordionRenderer';
import CardiovascularInvestigations from 'containers/CardiovascularInvestigations';
import MedicationsTable from 'containers/MedicationsTable';
import FrailtyScoreBlock from 'containers/MedicalInformationBlock/FrailtyScoreBlock';
import BaselineBloodworkBlock from 'containers/MedicalInformationBlock/BaselineBloodworkBlock';
import HospitalizationsTable from 'containers/MedicalInformationBlock/HospitalizationsTable';
import MedicalHistoryTable from 'containers/MedicalHistoryTable';
import ArrhythmiaHistoryTable from 'containers/ArrhythmiaHistoryTable';

const pages = [
  {
    component: MedicationsTable,
    route: '/medications',
    title: 'medicalInformation.medications',
  },
  {
    component: ArrhythmiaHistoryTable,
    route: '/arrhythmia-history',
    title: 'medicalInformation.arrhythmiaHistory',
  },
  {
    component: MedicalHistoryTable,
    route: '/medical-history',
    title: 'medicalInformation.medicalHistory',
  },
  {
    component: CardiovascularInvestigations,
    route: '/cardiovascular-investigations',
    title: 'medicalInformation.cardiovascularInvestigations',
  },
  {
    component: FrailtyScoreBlock,
    route: '/frailty-score',
    title: 'medicalInformation.frailtyScore',
  },
  {
    component: HospitalizationsTable,
    route: '/cardiovascular-hospitalizations',
    title: 'medicalInformation.cardiovascularHospitalizations',
  },
  {
    component: BaselineBloodworkBlock,
    route: '/baseline-bloodwork',
    title: 'medicalInformation.bloodwork',
  },
];

const PatientInformation = ({ match, t }) => (
  <Paper data-test="patientInfoBlock">
    <PaperTitle data-test="header">{t('patient.medicalInformation')}</PaperTitle>
    <AccordionRenderer pages={pages} parentPath={match.url} />
  </Paper>
);

PatientInformation.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PatientInformation);
